var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationConfirmation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.784 51.3335H5.83398V12.4834H15.7507V15.5168H8.86733V48.3H29.7507V40.8335H32.784V51.3335Z",
    fill: "#170F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7658 42.3496H17.7324V45.3828H20.7658V42.3496Z",
    fill: "#170F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0672 35.5835C42.1858 35.5835 48.7672 29.002 48.7672 20.8834C48.7672 12.7648 42.1858 6.18359 34.0672 6.18359C25.9486 6.18359 19.3672 12.7648 19.3672 20.8834C19.3672 29.002 25.9486 35.5835 34.0672 35.5835Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5505 27.3001L26.3672 21.117L28.4672 19.017L32.5505 23.1003L41.1839 14.4668L43.4005 16.5669L32.5505 27.3001Z",
    fill: "#170F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0663 37.1004C25.0829 37.1004 17.8496 29.7502 17.8496 20.8835C17.8496 12.0169 25.1996 4.66699 34.0663 4.66699C42.9329 4.66699 50.2829 12.0169 50.2829 20.8835C50.2829 29.7502 43.0496 37.1004 34.0663 37.1004ZM34.0663 7.58366C26.7163 7.58366 20.8829 13.5337 20.8829 20.767C20.8829 28.0004 26.8329 33.9504 34.0663 33.9504C41.4163 33.9504 47.2496 28.0004 47.2496 20.767C47.2496 13.5337 41.2996 7.58366 34.0663 7.58366Z",
    fill: "#170F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationConfirmation);
export default __webpack_public_path__ + "static/media/verification-confirmation.8ce87d4e561878a4ba818e3f87fa85ec.svg";
export { ForwardRef as ReactComponent };